import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { SessionContext } from "../context/SessionContext";
import { Toaster, toast } from "react-hot-toast";

import ToastDisplay from "../components/ToastDisplay";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Logo from "../components/Logo";
import Spinner from "react-bootstrap/Spinner";

const Login = () => {
	const navigate = useNavigate();
	const [session, setSession] = useContext(SessionContext);
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [info, setInfo] = useState(null);
	const [loading, setLoading] = useState(false);

	const authUser = async (e) => {
		e.preventDefault();
		setLoading(true);
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				email: email,
				password: password,
			}),
		};

		const response = await fetch(
			`${process.env.REACT_APP_API_URI}/users/login`,
			requestOptions
		);
		const data = await response.json();

		if (!response.ok) {
			toast(<ToastDisplay status="error" content={data.msg} />);
			setLoading(false);
			setPassword("");
		} else {
			setSession(data.session_token);
		}
	};

	useEffect(() => {
		if (session) {
			navigate("/");
		}
	}, [session]);

	return (
		<div className="full-page flex-column">
			<Toaster
				position="bottom-right"
				toastOptions={{ className: "snackbar-container" }}
			/>
			<Container className="flex-column">
				<Form
					onSubmit={authUser}
					className="rounded-8 bg-white p-30 col-lg-5 col-md-7 col-12"
				>
					<Logo className="mb-30" />
					<span className="text-sm mb-30 block opacity-7">
						Log in to your account.
					</span>
					<Row className="mb-20">
						<Col>
							<div className="login-input-container">
								<div className="login-input-icon flex-column">
									<i className="ri-user-line opacity-7" />
								</div>
								<Form.Control
									type="text"
									className="login-input text-sm"
									placeholder="Username/Email"
									value={email}
									onChange={(e) => setEmail(e.target.value)}
								/>
							</div>
						</Col>
					</Row>
					<Row className="mb-30">
						<Col>
							<div className="login-input-container">
								<div className="login-input-icon flex-column">
									<i className="ri-lock-2-line opacity-7" />
								</div>
								<Form.Control
									type="password"
									className="login-input text-sm"
									placeholder="Password"
									value={password}
									onChange={(e) => setPassword(e.target.value)}
								/>
							</div>
						</Col>
					</Row>
					<Row className="mb-30">
						<Col>
							<p className="label-md mb-0">
								By logging in, your agree to our{" "}
								<a className="decorated" href="/terms">
									Usage Terms
								</a>{" "}
								and{" "}
								<a className="decorated" href="/privacy">
									Privacy Policy
								</a>
								.
							</p>
						</Col>
					</Row>
					<Button
						type="submit"
						className="btn-default btn-md rounded-4 flex-column full"
						disabled={loading}
					>
						{loading ? <Spinner /> : "Log in"}
					</Button>
				</Form>
			</Container>
		</div>
	);
};

export default Login;
